export function filterCarriers(carriers, query) {
  const q = query.toLowerCase().trim();
  return [...carriers]
    .filter(item => item.name.toLowerCase().includes(q))
    .sort((a, b) => b.name.toLowerCase().startsWith(q) - a.name.toLowerCase().startsWith(q));
}
